import { writable } from "svelte/store"

export const user_cliente_planilla = writable({
  id_usuario: 0,
  tipo: "D",
  consultas: 0,
})

export const user_cliente_filtro = writable({
  id_usuario: 0,
})


export const user_cliente_api = writable({
  id_usuario: 0,
  api_key: "",
})
